import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getDirection(language: string): 'rtl' | 'ltr' {
  return ['he', 'ar'].includes(language) ? 'rtl' : 'ltr'
}

export function formatPhoneNumber(phone: string): string {
  // Format phone number based on locale
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
}
